/**
 * use-mounted.js
 */

import React from 'react';

export default function() {
  const mounted = React.useRef ( false );

  React.useEffect ( () => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, [] );

  return mounted;
}